import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { IProps } from './models';

export const Group: FC<IProps> = ({ Grid, children, styles = {}, ...props }) => {
    return (
        <Grid
            {...props}
            classNames={{
                col: cn(styles.external, styles.col),
                grid: cn(styles.external, styles.grid),
            }}
            collapse
            vertical
        >
            {children}
        </Grid>
    );
};
